(function () {
  // PERFORMANCE FIX: this file's own <script src> tag can be emitted more
  // than once on a page (the same skip_styles-per-section gap documented in
  // upk-pdp.js), and unlike that file, a second copy here isn't just wasted
  // parse/redeclare work - it's actively harmful: the shopify:section:load
  // listener below deliberately sets s.__rpInit = false before calling
  // init() again (so a real Theme Editor section reload still re-inits
  // correctly), which defeats the per-section guard. Two independent script
  // copies means two independent 'shopify:section:load' listeners, so a
  // single reload event calls initAutoSlide() twice on the same section -
  // and initAutoSlide() has no guard of its own, so that creates two fully
  // separate requestAnimationFrame loops with their own closures, both
  // scrolling the exact same carousel grid at once. This top-level guard -
  // the same pattern already used by upk-quickview.js and upk-currency.js -
  // keeps every copy after the first from registering anything at all, so
  // there is only ever one listener and one possible auto-slide loop.
  if (window.__upkRakhiLoaded) return;
  window.__upkRakhiLoaded = true;

  /* Rakhi Picks, Tabbed Products. Scoped to .rp-section; supports multiple
     independent instances on one page. No AJAX, all tab panels are rendered
     server-side up front (real Shopify product data per block), JS just shows/
     hides the matching panel, so switching tabs never reloads the page.

     REVISION 11: added initArrows, small prev/next buttons per panel that
     scroll that panel's .rp-grid by one card width. Each arrow auto-hides
     itself when there's nothing left to scroll to in that direction (or no
     overflow at all, e.g. desktop where all cards already fit). refreshArrows
     is also called after every tab switch, since a panel that was hidden
     (display:none) reports 0 for scrollWidth/clientWidth until it's shown.

     REVISION 16: added initPromoCopy, click-to-copy for the promo code
     chips below the tabs. Uses navigator.clipboard when available, falls
     back to a hidden-textarea + execCommand('copy') for older browsers.

     REVISION 17: promo code chips now render a code label + a copy icon
     (SVG) as separate child spans instead of the button's raw textContent.
     showCopied() used to overwrite the whole button's textContent, which
     silently deleted the icon element too. Now it only swaps the text in
     the .rp-promo-code-text span and leaves the icon node alone.

     REVISION 18: the auto-slide requestAnimationFrame loop previously
     rescheduled itself unconditionally forever, on every page with an
     autosliding section, even on desktop, where the `mq.matches` check
     inside the tick meant every single frame did nothing at all. That's a
     permanent 60fps loop for the entire time the tab is open. It's now
     started/stopped by the media query's own change event instead, so the
     loop only exists while the mobile breakpoint (<=860px) actually
     applies, identical slide behavior on mobile, zero per-frame work on
     desktop, and it correctly starts/stops if the viewport crosses the
     breakpoint (resize, orientation change, devtools resize). */

  function initTabs(section, refreshArrows) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-rp-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-rp-panel]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-rp-tab');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-rp-panel') === idx);
        });
        tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        loadPanel(panels.filter(function (p) { return p.getAttribute('data-rp-panel') === idx; })[0], refreshArrows);
        if (refreshArrows) refreshArrows();
      });
    });
  }

  /* P13c.2: a tab whose grid carries data-rp-src has no cards in the page. On its first tap the section is fetched rendered on
     the tab's collection URL (Section Rendering API: one JSON key per section id) and the cards of the panel with the same
     collection handle are copied in. One fetch per tab; a failure leaves the tab ready to try again. */
  function loadPanel(panel, refreshArrows) {
    if (!panel) return;
    var grid = panel.querySelector('[data-rp-grid][data-rp-src]');
    if (!grid || grid.dataset.rpLoaded) return;
    grid.dataset.rpLoaded = '1';
    var src = grid.getAttribute('data-rp-src');
    var handle = panel.getAttribute('data-rp-handle');
    var section = panel.closest('.rp-section');
    var sid = section ? section.id.replace(/^Tabs-/, '') : '';
    fetch(src, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (json) {
        var html = json[sid]; if (!html) throw new Error('no section');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var from = doc.querySelector('[data-rp-panel][data-rp-handle="' + handle + '"] [data-rp-grid]');
        if (!from) throw new Error('no grid');
        var frag = document.createDocumentFragment();
        Array.prototype.slice.call(from.children).forEach(function (n) { frag.appendChild(document.importNode(n, true)); });
        grid.innerHTML = ''; grid.appendChild(frag);
        grid.removeAttribute('aria-busy'); grid.removeAttribute('data-rp-src');
        if (window.upkLazy) window.upkLazy.watch(grid);
        if (window.upkWishlist && typeof window.upkWishlist.refresh === 'function') window.upkWishlist.refresh();
        if (refreshArrows) refreshArrows();
      })
      .catch(function () { delete grid.dataset.rpLoaded; grid.removeAttribute('aria-busy'); });
  }

  function initAutoSlide(section) {
    if (section.getAttribute('data-rp-autoslide') !== 'true') return;
    var speed = parseFloat(section.getAttribute('data-rp-speed')) || 0.3;
    var mq = window.matchMedia('(max-width: 860px)');
    var pauseUntil = new WeakMap();
    var dwellStart = new WeakMap();
    var rafId = null;

    section.querySelectorAll('[data-rp-grid]').forEach(function (grid) {
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (evt) {
        grid.addEventListener(evt, function () {
          pauseUntil.set(grid, Date.now() + 2800);
          grid.style.scrollSnapType = 'x proximity';
        }, { passive: true });
      });
    });

    function tick(ts) {
      var activePanel = section.querySelector('[data-rp-panel].is-active');
      var grid = activePanel ? activePanel.querySelector('[data-rp-grid]') : null;
      if (grid) {
        var until = pauseUntil.get(grid) || 0;
        if (Date.now() > until) {
          grid.style.scrollSnapType = 'none';
          var max = grid.scrollWidth - grid.clientWidth;
          if (max > 1) {
            if (grid.scrollLeft >= max - 1) {
              var start = dwellStart.get(grid);
              if (!start) {
                dwellStart.set(grid, ts);
              } else if (ts - start > 1400) {
                dwellStart.delete(grid);
                grid.scrollTo({ left: 0, behavior: 'smooth' });
              }
            } else {
              grid.scrollLeft += speed;
            }
          }
        }
      }
      rafId = requestAnimationFrame(tick);
    }
    function startLoop() {
      if (rafId == null) rafId = requestAnimationFrame(tick);
    }
    function stopLoop() {
      if (rafId != null) { cancelAnimationFrame(rafId); rafId = null; }
    }

    if (mq.matches) startLoop();
    if (mq.addEventListener) {
      mq.addEventListener('change', function (e) { if (e.matches) startLoop(); else stopLoop(); });
    } else if (mq.addListener) {
      // Safari <14 fallback
      mq.addListener(function (e) { if (e.matches) startLoop(); else stopLoop(); });
    }
  }

  function initArrows(section) {
    var carousels = Array.prototype.slice.call(section.querySelectorAll('.rp-carousel'));
    var updaters = [];

    carousels.forEach(function (carousel) {
      var grid = carousel.querySelector('[data-rp-grid]');
      var prev = carousel.querySelector('[data-rp-arrow="prev"]');
      var next = carousel.querySelector('[data-rp-arrow="next"]');
      if (!grid || !prev || !next) return;

      function update() {
        var max = grid.scrollWidth - grid.clientWidth;
        var hasOverflow = max > 2;
        prev.hidden = !hasOverflow || grid.scrollLeft <= 2;
        next.hidden = !hasOverflow || grid.scrollLeft >= max - 2;
      }

      function scrollByAmount(dir) {
        var card = grid.querySelector('.rp-slide');
        var amount = card ? card.getBoundingClientRect().width + 12 : grid.clientWidth * 0.8;
        grid.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { scrollByAmount(-1); });
      next.addEventListener('click', function () { scrollByAmount(1); });
      grid.addEventListener('scroll', update, { passive: true });

      updaters.push(update);
      update();
    });

    window.addEventListener('resize', function () {
      updaters.forEach(function (u) { u(); });
    });

    return function refresh() {
      updaters.forEach(function (u) { u(); });
    };
  }

  function initPromoCopy(section) {
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-rp-copy]'));
    if (!buttons.length) return;

    function showCopied(btn) {
      if (btn.__rpCopyTimeout) clearTimeout(btn.__rpCopyTimeout);
      var textEl = btn.querySelector('.rp-promo-code-text');
      var original = btn.__rpOriginalText || (textEl ? textEl.textContent : btn.textContent);
      btn.__rpOriginalText = original;
      if (textEl) {
        textEl.textContent = 'Copied!';
      } else {
        btn.textContent = 'Copied!';
      }
      btn.classList.add('is-copied');
      btn.__rpCopyTimeout = setTimeout(function () {
        if (textEl) {
          textEl.textContent = original;
        } else {
          btn.textContent = original;
        }
        btn.classList.remove('is-copied');
      }, 1500);
    }

    function fallbackCopy(text, btn) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      showCopied(btn);
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-rp-copy');
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            showCopied(btn);
          }).catch(function () {
            fallbackCopy(code, btn);
          });
        } else {
          fallbackCopy(code, btn);
        }
      });
    });
  }

  function init(section) {
    if (section.__rpInit) return;
    section.__rpInit = true;
    var refreshArrows = initArrows(section);
    initTabs(section, refreshArrows);
    initAutoSlide(section);
    initPromoCopy(section);
  }

  function boot() {
    document.querySelectorAll('.rp-section').forEach(init);
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var sections = e.target.querySelectorAll ? e.target.querySelectorAll('.rp-section') : [];
    sections.forEach(function (s) { s.__rpInit = false; init(s); });
  });
})();
